<template>
  <form>
    <md-card class="mt-4" style="box-shadow:none">
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h2 class="title" style="font-weight:bold!important">
          New Profile
        </h2>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Name
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.name" />
              <validation-error :errors="apiValidationErrors.nombre" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Email
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.email" />
              <validation-error :errors="apiValidationErrors.email" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Phone
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.phone" />
              <validation-error :errors="apiValidationErrors.telefono" />
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { ValidationError } from "@/components";

export default {
  name: "add-profile-card",

  props: {
    user: Object,
    apiValidationErrors: Object
  },

  watch: {  
      'user.name'(value){  
        this.apiValidationErrors.nombre = [];
      },
      'user.email'(value){  
        this.apiValidationErrors.email = [];
      },
      'user.phone'(value){  
        this.apiValidationErrors.telefono = [];
      }
    },

  components: { ValidationError },


  data() {
    return {
      default_img: process.env.VUE_APP_BASE_URL + "/img/placeholder.jpg",
    };
  },

  methods: {
  },
};
</script>

<style></style>
